import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
import { AiFillCaretRight } from "react-icons/ai";
import { Spinner } from "reactstrap";
import { ROUTES } from "../../../helpers/constants";
import CatalogAPI from "../../../services/api/catalog.api";
import PurchaseAPI from "../../../services/api/purchase.api";
import ProductCard from "./components/product-card";
import InvoiceSummary from "./components/invoice-summary";
import TermsModal from "./components/terms-modal";

const Checkout = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const client = state?.client;
  const initialPlanId = state?.plan?.id;

  const [plan, setPlan] = useState(null);
  const [baseUnitPrice, setBaseUnitPrice] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!initialPlanId) {
      navigate(ROUTES.PURCHASE.route, { replace: true });
      return;
    }
    if (!client) {
      navigate(ROUTES.CLIENTS.route, { replace: true });
      return;
    }

    setFetching(true);
    CatalogAPI.getCatalog()
      .then((res) => {
        const catalog = res?.data ?? [];
        const fresh = catalog.find((p) => p.id === initialPlanId);
        if (!fresh) {
          toast.error("El plan seleccionado ya no está disponible.");
          navigate(ROUTES.PURCHASE.route, { state: { client }, replace: true });
          return;
        }
        const individual = catalog.find((p) => p.testsQuantity === 1);
        setBaseUnitPrice(individual?.totalPrice ?? null);
        setPlan(fresh);
      })
      .catch(() => {
        toast.error("No se pudo cargar la información del plan.");
        navigate(ROUTES.PURCHASE.route, { state: { client }, replace: true });
      })
      .finally(() => setFetching(false));
  }, [initialPlanId, client, navigate]);

  const handleConfirm = async () => {
    if (!plan || !client?.id) return;
    setLoading(true);
    try {
      const response = await PurchaseAPI.createPaymentIntention({
        clientId: client.id,
        catalogId: plan.id,
      });
      if (response?.data?.redirectUrl) {
        window.location.href = response.data.redirectUrl;
      } else {
        toast.success("Intención de pago creada correctamente");
      }
    } catch {
      toast.error("No se pudo crear la intención de pago. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  if (!initialPlanId || !client) return null;

  if (fetching) {
    return (
      <div className="gm-clients-details-container">
        <div className="gm-checkout-loading">
          <Spinner size="sm" />
          &nbsp; Cargando...
        </div>
      </div>
    );
  }

  return (
    <div className="gm-clients-details-container">
      <Toaster />

      <div className="gm-cd-top-navigation">
        <div className="gm-cd-top-info">
          <button
            className="gm-cd-back"
            type="button"
            onClick={() =>
              navigate(ROUTES.PURCHASE.route, { state: { client } })
            }
          >
            Volver
          </button>
          {client?.name && (
            <>
              <AiFillCaretRight />
              <div className="gm-cd-company-info">{client.name}</div>
            </>
          )}
        </div>
      </div>

      <div className="gm-folder-container">
        <div className="gm-checkout-box">
          <div className="gm-checkout-grid">
            <ProductCard plan={plan} />
            <InvoiceSummary
              plan={plan}
              baseUnitPrice={baseUnitPrice}
              termsAccepted={termsAccepted}
              onTermsChange={setTermsAccepted}
              onOpenTerms={() => setTermsOpen(true)}
              onConfirm={handleConfirm}
              loading={loading}
            />
          </div>
        </div>

      </div>

      <TermsModal
        open={termsOpen}
        toggle={() => setTermsOpen((o) => !o)}
        onAccept={() => setTermsAccepted(true)}
      />
    </div>
  );
};

export default Checkout;
